// extracted by mini-css-extract-plugin
export default {"sold-price-tit":"Rank_sold-price-tit__K5qjL","sold-tit":"Rank_sold-tit__nU3KL"};